import i18next from "i18next";
import * as Yup from "yup";

export const productValidationSchema = (t: typeof i18next.t) => {
  return Yup.object({
    name: Yup.string().required(t("admin.products.side.form.productNameErrorMsg")),
  });
} 
